import React from 'react';
import { useCurrency } from '../../contexts/CurrencyContext';
import Select from './Select';

const CurrencySelector = () => {
  const { currency, setCurrency } = useCurrency();

  const currencyOptions = [
    { value: 'CAD', label: 'CAD $' },
    { value: 'USD', label: 'USD $' },
    { value: 'EUR', label: 'EUR €' }
  ];

  return (
    <div style={{
      position: 'fixed',
      bottom: 'var(--spacing-md)',
      right: 'var(--spacing-md)',
      zIndex: 100
    }}>
      <Select
        options={currencyOptions}
        value={currency}
        onChange={setCurrency}
        style={{ minWidth: '100px' }}
        openUpward={true}
      />
    </div>
  );
};

export default CurrencySelector;
